import React, { useContext, useEffect } from "react";
import { useAsyncError, useHistory } from "react-router-dom";
import { useState, useRef } from "react";
import {
  Routes,
  Route,
  Link,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { auth, googleProvider, app } from "./config/firebase";
import Profile from "./Profile";
import { UserContext } from "./userFile";

function SignupLogin() {
  return (
    <>
      <div>
        {/* <div className="row py-3">
          <Link
            className="btn btn-outline-success col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 "
            to="login"
          >
            Login
          </Link>
          <Link
            className="btn btn-success col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 "
            to="signup"
          >
            Sign up
          </Link>
        </div> */}
        <h4>Sign in</h4>
        <Routes>
          <Route path="/*" index element={<Login />} />
          <Route path="signup/*" element={<Signup />} />

          <Route path="login/*" element={<Login />} />
          <Route path="signup/*" element={<Signup />} />
        </Routes>
      </div>
    </>
  );
}

export default SignupLogin;

const Login = () => {
  const navigate = useNavigate();
  const user = useContext(UserContext);

  const createAccountWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      // Check if user context is set (user is signed in)
      if (user) {
        navigate("/profile");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className="border google-login bg-success text-light rounded"
        onClick={createAccountWithGoogle}
      >
        {/* <div class="mb-3">
        <label for="exampleFormControlInput1" class="form-label">
          Email address
        </label>
        <input
          type="email"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="name@example.com"
          // onChange={(e) => setEmail(e.target.value)}
        />
        </div>
        <label for="inputPassword5" class="form-label">
        Password
        </label>
        <input
        type="password"
        id="inputPassword5"
        class="form-control"
        aria-describedby="passwordHelpBlock"
        placeholder="password"
        // onChange={(e) => setPassword(e.target.value)}
        />
        <div id="passwordHelpBlock" class="form-text py-3">
          Your password must be 8-20 characters long, contain letters and numbers,
          and must not contain spaces, special characters, or emoji.
        </div> */}

        <div className="btn-container">
          {/* <button type="button" class="btn col-5 btn-primary">
        </button> */}
          {/* <Link to="/profile" class="btn col-12 btn-success py-6 ">
          <span className="text-light">Login</span>
        </Link> */}
          <div className="d-flex align-items-center justify-content-evenly w-75 my-3 ">
            <i className="fab fa-google"></i>
            <span>Sign in with Google</span>
          </div>
          {/* <button type="button" class="btn btn-link py-6">
          Forgot password?
        </button> */}

          {/* <button type="button">
        </button> */}
          {/* <Link to="/signup" class="btn btn-success py-6 col-12">
          <span className="text-light">Create new account</span>
        </Link> */}
          {/* <Routes>
          <Route path='signup' element={<Signup />} />
        </Routes> */}
        </div>
      </div>
    </>
  );
};

const Signup = () => {
  // const firstName = useRef(null);
  // const lastName = useRef(null);
  // // const email = useRef(null);
  // // const password = useRef(null);
  // const university = useRef(null);
  // const college = useRef(null);
  // const state = useRef(null);
  // const gender = useRef(null);

  // const signIn = async () => {
  // };
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  console.log(auth?.currentUser?.email);

  const createAccount = async () => {
    try {
      await createUserWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.log(err);
    }
  };

  const logOut = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.log(err);
    }
    console.log(auth?.currentUser?.email);
  };
  // console.log(email);
  // console.log(password);
  // console.log(firstName.current.value);
  // console.log(lastName.current.value);
  // console.log(email.current.value);
  // console.log(password.current.value);
  // console.log(university.current.value);
  // console.log(college.current.value);
  // console.log(state.current.value);
  // console.log(gender.current.value);

  return (
    <div className="signup">
      <div class="row">
        <div class="col py-2">
          <input
            type="text"
            class="form-control"
            placeholder="First name"
            aria-label="First name"
            // ref={firstName}
          />
        </div>
        <div class="col py-2 ">
          <input
            type="text"
            class="form-control"
            placeholder="Last name"
            aria-label="Last name"
            // ref={lastName}
          />
        </div>
      </div>

      <div class="mb-3">
        <label for="exampleFormControlInput1" class="form-label ">
          Email address
        </label>
        <input
          type="email"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="name@example.com"
          // ref={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <label for="inputPassword5" class="form-label">
        Password
      </label>
      <input
        type="password"
        id="inputPassword5"
        class="form-control"
        aria-describedby="passwordHelpBlock"
        // ref={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div id="passwordHelpBlock" class="form-text py-2 ">
        Your password must be 8-20 characters long, contain letters and numbers,
        and must not contain spaces, special characters, or emoji.
      </div>

      <div class="row">
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            placeholder="University"
            aria-label="University"
            // ref={university}
          />
        </div>
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            placeholder="College"
            aria-label="College"
            // ref={college}
          />
        </div>
        <select class="form-select col" aria-label="Default select example">
          <option selected>State</option>
          <option value="Khartoum">Khartoum</option>
          <option value="Portsudan">Portsudan</option>
          <option value="Aljazeera">Aljazeera</option>
        </select>
        <div className="gender py-2 ">
          <input
            type="checkbox"
            class="btn-check"
            id="btn-check-4"
            autocomplete="off"
            // ref={gender}
          />
          <label class="btn" for="btn-check-4">
            Male
          </label>

          <input
            type="checkbox"
            class="btn-check"
            id="btn-check-5"
            autocomplete="off"
            // ref={gender}
          />
          <label class="btn" for="btn-check-5">
            Female
          </label>
        </div>
      </div>
      {/* <button type="submit">
      </button> */}
      <Link
        to="/profile"
        class="btn btn-success col-12"
        onClick={createAccount}
      >
        <span className="text-light">Create account</span>
      </Link>
      {/* <button className="btn btn-info">
        Sign up with Google
      </button> */}
      {/* <button className="btn btn-danger" onClick={logOut}>
        Sign out
      </button> */}
    </div>
  );
};

export const UserName = () => {
  return (
    <>
      <p> Mazin Salih </p>
    </>
  );
};
